import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/node_modules/@interness/web-core/src/templates/mdx/default.js";
import { graphql } from 'gatsby';
import CallToAction from '@interness/theme-sonora/src/components/CallToAction/CallToAction';
import Lightbox from '@interness/web-core/src/components/media/Lightbox/Lightbox';
export const query = graphql`
  query {
    gallery: directusMediaCollection(name: {eq: "trauringschmiedekurs-ergebnisse"}) {
      ...LightboxGalleryGrid
    }
  }
`;
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Wrapper = makeShortcode("Wrapper");
const Link = makeShortcode("Link");
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<hr></hr>
<h1>{`Trauring-Schmiedekurs Ergebnisse`}</h1>
<hr></hr>
<Wrapper mdxType="Wrapper">
<Link to='/atelier-service/trauringschmiedekurs' mdxType="Link">Zurück zur Kursübersicht</Link>
<hr></hr>
<Lightbox images={props.data.gallery.images} thumbnails={props.data.gallery.thumbnails} fromApi mdxType="Lightbox" />
</Wrapper>
<hr></hr>
<CallToAction mdxType="CallToAction" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      